import api from "@/services/api";

const reportSphSpkService = {
  getList(params) {
    return api.get('/report/monitoring-sph-spk', { params });
  },

  exportExcel(params) {
    return api.get('/report/monitoring-sph-spk/export-excel', {
      params,
      responseType: 'blob',
    });
  },
};

export default reportSphSpkService;
